export default __webpack_public_path__ + "static/media/focus-bg.c568881e.png";